import React, {useState} from 'react';

const ContactInfoModal = ({ isOpen, onClose, conversation, onAssignClient }) => {
    const [selectedClient, setSelectedClient] = useState("");

    if (!isOpen || !conversation) return null;

    const possibleClients = conversation.possibleClients || [];
    const hasMultipleClients = possibleClients.length > 1;

    const handleAssignClick = () => {
        if (!selectedClient) return;
        onAssignClient(Number(selectedClient));
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal-content" onClick={e => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>Información del Contacto</h3>
                    <button onClick={onClose} className="close-modal-btn">×</button>
                </div>
                
                <div className="modal-form">
                    <div className="form-group">
                        <label>Nombre del Contacto</label>
                            {hasMultipleClients ? (
                                <>
                                    {/* <select
                                        value={selectedClient}
                                        onChange={(e) => setSelectedClient(e.target.value)} >
                                            <option value = ""> Seleccione un cliente</option>
                                            {possibleClients.map(client => (
                                                <option key ={client.idCliente} value={client.idCliente}>
                                                    {client.nombreCompleto}
                                                </option>
                                            ))}
                                        </select> */}

                                       <select
                                        className="contact-info-display "
                                        style={{ width: "100%" }}
                                        value={selectedClient}
                                        onChange={async (e) => {
                                            const clientId = e.target.value;
                                            setSelectedClient(clientId);
                                            if (!clientId) return;

                                            try {
                                                await onAssignClient(Number(clientId));
                                            } catch (error) {
                                                console.error(error);
                                                alert(error.message);
                                            }
                                            }}
                                         >
                                            <option value = ""> Seleccione un cliente</option>
                                            {possibleClients.map(client => (
                                                <option key ={client.idCliente} value={client.idCliente}>
                                                    {client.nombreCompleto}
                                                </option>
                                            ))}
                                        </select>

                                        
                                </>
                            ):(
                               <div className="contact-info-display">
                                  {conversation.nombreContacto || 'Sin nombre'}
                               </div>
                            )}
                    </div>
                    
                    <div className="form-group">
                        <label>Número de WhatsApp</label>
                        <div className="contact-info-display phone-number">
                            {conversation.numeroWhatsapp}
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <label>Estado</label>
                        <div className="contact-info-display">
                            {conversation.estado}
                        </div>
                    </div>
                    
                    {conversation.atendidaPor && (
                        <div className="form-group">
                            <label>Atendida por</label>
                            <div className="contact-info-display">
                                {conversation.atendidaPor}
                            </div>
                        </div>
                    )}
                    
                    <div className="modal-actions">
                        <button type="button" onClick={onClose}>
                            Cerrar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactInfoModal;